export interface NewsItem {
  id: string;
  title: string;
  category: string;
  date: string;
  author: string;
  summary: string;
  cover: string;
  body: string[];
  relatedIds: string[];
  hot?: boolean;
}

export const newsCategories = ['全部', '影视资讯', '影评解读', '活动公告', '行业观察'];

export const newsList: NewsItem[] = [
  {
    id: 'silent-code-record',
    title: '《静默代码》上线三周播放破 2.4 亿，科幻悬疑正在回到观众视野',
    category: '影视资讯',
    date: '2026-10-15',
    author: '编辑部 · 沈知',
    summary:
      '开播即登顶周榜的《静默代码》，用一场关于"算法与记忆"的调查，把国产悬疑剧的叙事密度推到了新的位置。我们和数据团队聊了聊，为什么它能在三周内破 2.4 亿次播放。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20dark%20modern%20control%20room%20with%20glowing%20amber%20screens%2C%20cinematic%20blue%20shadows%2C%20no%20people%2C%20magazine%20feature%20visual&width=1200&height=700&seq=news-silentcode-2026&orientation=landscape',
    body: [
      '截止本周，《静默代码》累计播放量突破 2.4 亿，成为本季度关注度最高的剧集之一。与常见的强冲突悬疑不同，这部剧把大量篇幅留给了"调查"本身：翻日志、对时间线、在几十条没有音轨的录像里寻找一个可能根本不存在的决策人。',
      '剧集主创在采访中提到，故事的起点是一个很朴素的问题："如果一座城市开始自己做决定，我们还能查到是谁决定的吗？"为了让这种抽象的问题变得可看，编剧组把每一集的结构都做成了一次小型核对流程——观众和主角拿着同样的线索，一起往下走。',
      '平台数据显示，该剧的完播率明显高于同期同类型剧集，第二集到第四集的留存曲线几乎没有回落。运营方认为，这说明观众对于需要动脑的内容依然有耐心，只是需要被更清楚地引导。',
      '值得关注的是，剧集在视觉上也做了取舍：大量夜景、低饱和的处理、以及几乎固定的几个场景，把预算集中放在了信息量最大的镜头里。这种"把钱花在看得见信息的地方"的做法，正在被更多国产剧团队参考。',
      '本周五，《静默代码》将更新至第 20 集，剧情将首次正面回应"预测算法"与世界线之间的关系。我们也会在更新后第一时间带来更详细的解读。',
    ],
    relatedIds: ['deepwater-archive-review', 'tv-production-trend', 'steel-sky-visual'],
    hot: true,
  },
  {
    id: 'last-lighthouse-review',
    title: '影评 |《最后的灯塔》：把悬念藏在每一次呼吸里',
    category: '影评解读',
    date: '2026-10-13',
    author: '特约影评人 · 顾沉',
    summary:
      '《最后的灯塔》并不急着告诉你答案。它用大量的风声、潮声和一盏灯的明暗，把观众放进了那座塔里，让你自己去辨认哪一个方向的信号才是真的。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20lighthouse%20on%20a%20cliff%20at%20dusk%20with%20storm%20clouds%2C%20warm%20lantern%20beam%2C%20dark%20blue%20sea%2C%20cinematic%20magazine%20feature&width=1200&height=700&seq=news-lighthouse-2026&orientation=landscape',
    body: [
      '看《最后的灯塔》的前三十分钟，你可能会以为这是一部靠气氛取胜的悬疑片。海浪、雨声、锈掉的铁门、一页页被水泡皱的日志——导演陈砚舟几乎把所有对白都往后推，只留下环境声和主角陆行舟的呼吸。',
      '但真正让这部电影站住的，是它对"证据"的处理。陆行舟发现的讯号不是一个谜题的答案，而是一种负担：当你知道某个真相，却无法向任何人证明时，你会怎么做？影片把这个问题重复了四次，每次给出的回应都比上一次更沉默。',
      '张景川的表演是本片最大的惊喜。他几乎没有大段的情绪爆发，所有重量都压在肩膀和呼吸上。片尾那场在雷达室里的独角戏，是本年度最有力量的一分钟。',
      '当然它并不完美。中段的部分闪回略显冗长，配乐的介入也有几次抢了表演的空间。但当最后那束光照向海面时，这些小问题似乎都变得无关紧要。',
      '推荐指数：9.1 / 10。适合安静地看完，最好是在一个下雨的晚上。',
    ],
    relatedIds: ['silent-code-record', 'mountain-sings-doc', 'dead-sea-review'],
    hot: true,
  },
  {
    id: 'autumn-picks-2026',
    title: '十月片单：8 部值得留出一个晚上的新片',
    category: '影视资讯',
    date: '2026-10-11',
    author: '编辑部 · 林溪',
    summary:
      '从深海悬疑到海边小镇的面包房，本月上线的新片涵盖了几乎所有的观看心情。我们按照"想动脑 / 想放空 / 想被治愈"整理成了三组推荐。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20flat%20lay%20of%20film%20clapperboard%20and%20autumn%20leaves%20on%20a%20light%20gray%20desk%2C%20warm%20amber%20accents%2C%20minimal%20magazine%20styling&width=1200&height=700&seq=news-octpicks-2026&orientation=landscape',
    body: [
      '每到换季，平台的上新节奏都会快起来。这个十月尤其如此：既有大制作的科幻片，也有几部成本不高但口碑极好的独立作品。',
      '想动脑的一组，我们推荐《静默代码》《深海档案》和《最后的灯塔》。三部作品的共同点是信息密度高，但它们处理信息的方式完全不同：一部靠数据，一部靠环境，一部靠沉默。',
      '想放空的一组，可以看《钢之上空》和《霓虹追缉》。这两部都不需要太多前情，坐下来看视效和大场面就好，非常适合周末深夜。',
      '想被治愈的一组，推荐《晴日面包房》《格子里的春天》和《云上的家》。它们没有强烈的戏剧冲突，节奏缓慢，但看完会让人想去做点具体的事，比如烤一炉面包，或给很久没联系的朋友发条消息。',
      '最后提醒一下：以上作品的资源信息均在详情页中标注，实际可观看的平台与清晰度以平台说明为准。',
    ],
    relatedIds: ['tv-production-trend', 'onetable-food-doc', 'silent-code-record'],
  },
  {
    id: 'onetable-food-doc',
    title: '当综艺开始认真拍一道菜，《一桌好戏》做到了什么',
    category: '影评解读',
    date: '2026-10-08',
    author: '特约作者 · 白露',
    summary:
      '很多美食综艺把镜头对准成品，而《一桌好戏》把镜头对准了手。切菜的节奏、灶火的颜色、旧饭盒上的划痕，这些细节构成了它真正的叙事。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20weathered%20hands%20slicing%20vegetables%20on%20a%20wooden%20board%20in%20warm%20kitchen%20light%2C%20documentary%20style%2C%20shallow%20depth%20of%20field&width=1200&height=700&seq=news-onetable-2026&orientation=landscape',
    body: [
      '在《一桌好戏》里，你能数清一位老人切土豆丝用了几分钟。节目没有剪掉这些"无聊"的时间，反而给了一个固定的机位，完整地看下去。',
      '这种选择带来的效果是明显的：当最后那盘菜端上桌时，观众能感觉到它是有重量的。不是因为它多好吃，而是因为我们已经看完了它从生到熟的整个过程。',
      '三位主理人在节目里更像学生。他们会问很基础的问题：为什么这道菜一定要用这种油？为什么这个季节不适合腌？这些问题恰好是大多数观众想问、又不好意思问的。',
      '节目的另一条线索是"旧饭盒"。每一期开头，主理人都会先打开一个用旧的铝饭盒，里面装着当期要寻找的菜的味道线索。这个小小的道具，把整季节目的情绪串了起来。',
      '如果你最近有点累，这档节目很适合在吃饭的时候打开。它不催你，也不煽情，只是认真地做一桌菜。',
    ],
    relatedIds: ['autumn-picks-2026', 'green-room-talk', 'sunny-bakery-warm'],
  },
  {
    id: 'tv-production-trend',
    title: '行业观察：短剧集为什么越来越多？',
    category: '行业观察',
    date: '2026-10-05',
    author: '行业组 · 周予',
    summary:
      '从 32 集到 12 集，再到 8 集的迷你剧，剧集长度的变化不只是平台策略，也在悄悄改变观众与故事之间的关系。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20minimalist%20photo%20of%20stacked%20film%20canisters%20and%20a%20notebook%20on%20a%20cool%20gray%20studio%20table%2C%20soft%20directional%20light%2C%20industry%20magazine%20style&width=1200&height=700&seq=news-shortseries-2026&orientation=landscape',
    body: [
      '过去两年，我们统计了新上线的国产剧集长度，发现 12 集以内的作品占比从 9% 上升到了 27%。这个变化在悬疑、犯罪和科幻类型中尤其明显。',
      '原因并不复杂。第一，观众的时间变得更碎片化，长剧的追看成本变高；第二，平台更愿意把预算集中在一部作品的制作质量上，而不是靠集数摊薄成本；第三，短剧集更容易被完整看完，完播数据也更漂亮。',
      '但短并不意味着简单。几位编剧向我们提到，短剧集对结构的容错率更低："你没有第三集可以用来热身，第一集前十分钟就必须让人相信这个故事。"',
      '另一个值得注意的趋势是"单元式迷你剧"的回归。每集一个相对独立的事件，但共享人物与世界观，这种结构既能保持节奏，也能让观众随时进入。',
      '可以预见的是，未来一两年，8 到 12 集的精品剧集会继续增多。对于创作者来说，这是一个好机会，也是一个更高的门槛。',
    ],
    relatedIds: ['silent-code-record', 'autumn-picks-2026', 'deepwater-archive-review'],
  },
  {
    id: 'steel-sky-visual',
    title: '《钢之上空》视效解析：一座城市是怎么被"造"出来的',
    category: '影视资讯',
    date: '2026-10-02',
    author: '技术组 · 何斯',
    summary:
      '影片里那座悬在云层上的钢铁城市，包含了 3400 万个独立组件。我们和视效团队聊了聊，为什么他们坚持要让每一块钢板的锈迹都不一样。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20behind%20the%20scenes%20photo%20of%20a%20modern%20VFX%20studio%20with%20large%20screens%20showing%20a%20floating%20city%20model%2C%20cool%20lighting%20with%20warm%20screens&width=1200&height=700&seq=news-steelsky-2026&orientation=landscape',
    body: [
      '《钢之上空》最让人记住的，是那座城市在晨光里慢慢显形的三分钟长镜头。镜头穿过层层云海，掠过上万块钢板、管道与维护通道，最后停在一扇起了锈的检修门上。',
      '视效总监告诉我们，这三分钟里出现的每一个组件都被单独建模过，总数超过 3400 万。为了不让城市看起来像塑料模型，团队编写了一套"锈迹程序"，让每一块钢板的氧化程度、雨水痕迹和修补焊疤都不相同。',
      '更难的是云。云层既要能承载城市，又不能遮住观众的视线。团队最终选择了一种混合方案：近景使用体积云，中景使用多层半透明板，远景则直接画进天空环境里。',
      '影片的艺术指导提到了一句很有意思的话："我们不是在造一座未来城市，我们是在造一座已经老了的未来城市。"这句话几乎解释了影片所有的视觉选择。',
      '如果你还没看过，建议选择最大的银幕。这三分钟在大银幕和小屏幕上，是两个完全不同的体验。',
    ],
    relatedIds: ['silent-code-record', 'autumn-picks-2026', 'last-lighthouse-review'],
  },
  {
    id: 'deepwater-archive-review',
    title: '《深海档案》为什么让人不敢开灯看',
    category: '影评解读',
    date: '2026-09-28',
    author: '特约影评人 · 顾沉',
    summary:
      '八集的迷你剧，几乎全部发生在同一座海上观测站。极小的空间，极少的角色，却做出了今年最紧绷的一部悬疑作品。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20dim%20deep%20sea%20research%20station%20corridor%20with%20orange%20emergency%20lights%2C%20wet%20metal%20walls%2C%20cinematic%20unease&width=1200&height=700&seq=news-deepwater-2026&orientation=landscape',
    body: [
      '《深海档案》的聪明之处，在于它几乎不让你看到海。整部剧的视角都被限制在观测站的走廊、舱室与潜水钟里，海只以声音和压力的形式存在。',
      '这种限制产生了一种很特别的恐惧：你不需要知道外面有什么，你只需要知道这扇门的另一侧正在被推。',
      '八集的长度刚好。前四集建立规则，后四集逐一打破。最后两集的节奏几乎是失控的，但那是好的失控——你会在同一时间想要暂停又想要继续。',
      'Eleanor Wise 的表演克制到近乎冷淡，但这种冷淡恰好是角色需要的。她在最后那场独白里终于松动的表情，值得一座奖杯。',
      '推荐指数：8.8 / 10。深夜观看效果最佳，但请记得开一盏灯。',
    ],
    relatedIds: ['silent-code-record', 'tv-production-trend', 'steel-sky-visual'],
  },
  {
    id: 'mountain-sings-doc',
    title: '四年十一座山：《山河有声》的拍摄手记',
    category: '影视资讯',
    date: '2026-09-24',
    author: '纪录片组 · 叶知',
    summary:
      '纪录片《山河有声》用了四年时间，跟随山地生态的变化走完十一座山系。导演叶清和写下了这段拍摄里最难的时候。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20layered%20mountain%20ridges%20at%20sunrise%20with%20sea%20of%20clouds%2C%20warm%20amber%20light%2C%20documentary%20landscape%2C%20no%20people&width=1200&height=700&seq=news-mountainsings-2026&orientation=landscape',
    body: [
      '第一年的拍摄几乎全废了。我们在雪线以上等了四十天，只有三天有合适的云层。摄影指导说，这不是运气问题，是我们还不了解这座山的时间表。',
      '第二年，我们开始住在村子里。白天跟着放牧的人走，晚上听老人讲哪一年雪化得早、哪一年河里的鱼少了。这些口述没有进入成片，但它们决定了我们要拍什么。',
      '《山河有声》最终的结构是四季。春拍水，夏拍草，秋拍迁徙，冬拍静默。每一季都有固定的三个机位，四年下来，我们有了同一片山谷最完整的影像档案。',
      '拍摄过程中最难的决定，是放弃一个"太好看"的镜头。有一次我们拍到了难得的日照金山，但当它被放进片子时，反而压掉了前后所有关于居民生活的段落。我们最后把它剪掉了。',
      '这部片子上线后，有很多人来信，说想带着家人去看看那些地方。这可能是纪录片最希望听到的反馈。',
    ],
    relatedIds: ['last-lighthouse-review', 'autumn-picks-2026', 'onetable-food-doc'],
  },
  {
    id: 'green-room-talk',
    title: '《绿房间》第二季启动：这次想聊聊"放弃"',
    category: '活动公告',
    date: '2026-09-20',
    author: '平台运营组',
    summary:
      '第二季《绿房间》将聚焦创作者的低谷时刻。征集通道现已开启，欢迎分享那些没有做成的作品背后的故事。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20an%20intimate%20studio%20corner%20with%20green%20walls%2C%20warm%20lamp%2C%20plants%20and%20two%20empty%20chairs%2C%20soft%20cinematic%20light&width=1200&height=700&seq=news-greenroom-2026&orientation=landscape',
    body: [
      '《绿房间》第二季正式启动，本季主题为"放弃"。我们想聊的不是成功经验，而是那些被搁置的剧本、解散的剧组、以及创作者在深夜删掉的文件夹。',
      '节目将继续采用一小时的深度对谈形式，不设提词器，不预设问题。录制地点仍然在那间摆满绿植的小房间。',
      '征集通道现已开启。如果你有想分享的创作经历，可以通过本站"关于我们"页面的联系邮箱投稿。请在邮件标题中注明"绿房间投稿"。',
      '第一季已在平台上线，共 12 期，涵盖编剧、摄影、剪辑、声音设计与独立导演等领域。',
      '第二季预计于 2027 年春季上线，敬请期待。',
    ],
    relatedIds: ['onetable-food-doc', 'tv-production-trend', 'autumn-picks-2026'],
  },
  {
    id: 'sunny-bakery-warm',
    title: '小而暖的故事为什么总能赢：《晴日面包房》观后',
    category: '影评解读',
    date: '2026-09-16',
    author: '特约作者 · 白露',
    summary:
      '一部每集只有十分钟讲述一位客人的日剧，凭什么在评分榜上稳住了 8.6 分？答案可能很简单：它认真对待了"日常"这个词。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20fresh%20bread%20loaves%20on%20a%20wooden%20bakery%20counter%20in%20soft%20morning%20window%20light%2C%20warm%20minimal%20food%20photography&width=1200&height=700&seq=news-sunnybakery-2026&orientation=landscape',
    body: [
      '《晴日面包房》的每一集都在凌晨四点开始。镜头里是揉面的手、发酵的盆、预热到合适温度的烤箱，然后才是一个客人的故事。',
      '这种叙事顺序很重要。它先让你相信这家店是真实运转的，然后才让你关心走进来的人。',
      '剧集里没有一个真正的反派。偶尔有人在生活里做错了选择，但剧集不评判，也不会给出惩罚式的结局。它只是让那件事发生，然后接着烤下一炉面包。',
      '这种克制的温柔，在现在的剧集里反而稀缺。我们习惯了强情节，习惯了每一集都要有一个爆点，但有时候观众真正需要的，只是一段可以安心度过的时间。',
      '豆瓣短评里有人说，看完第十集他去买了一袋面粉。这大概就是一部好剧能带来的最好结果。',
    ],
    relatedIds: ['onetable-food-doc', 'autumn-picks-2026', 'last-lighthouse-review'],
  },
  {
    id: 'dead-sea-review',
    title: '影评 |《时间沙丘》：他每年只出现一个季节',
    category: '影评解读',
    date: '2026-09-10',
    author: '特约影评人 · 顾沉',
    summary:
      '这部法国电影几乎没有情节，却在九十分钟里讲完了一段关系最完整的形状：相遇、等待、以及最终的缺席。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20vast%20sand%20dunes%20at%20golden%20hour%20with%20long%20shadows%2C%20warm%20orange%20tones%2C%20minimalist%20landscape%2C%20no%20people&width=1200&height=700&seq=news-dunetime-2026&orientation=landscape',
    body: [
      '《时间沙丘》的两位主角在大约七十分钟的片长里，对话不足两百句。大部分时间里，他们只是并肩坐着，看沙漠里的风改变沙丘的形状。',
      '导演 Camille Laurent 用一种近乎纪录片的克制拍摄了这段关系。没有背景音乐推动，没有特写煽情，所有的情绪都由光线和距离承担。',
      '影片最动人的地方在于它的结构：每一年都以同一句台词开场，但这句话的语气每一年都在变化。到了第五年，那句简单的问候已经带上了明显的重量。',
      '如果要说缺点，后半段的节奏确实偏慢，对习惯强叙事的观众来说可能会有些挑战。但如果你愿意把自己交给它，它会给你一个非常安静的夜晚。',
      '推荐指数：8.7 / 10。',
    ],
    relatedIds: ['last-lighthouse-review', 'deepwater-archive-review', 'sunny-bakery-warm'],
  },
  {
    id: 'award-season-2026',
    title: '活动公告｜2026 年度观众选择奖提名名单公布',
    category: '活动公告',
    date: '2026-09-05',
    author: '平台运营组',
    summary:
      '本次观众选择奖共设置八个奖项，覆盖电影、剧集与综艺。投票通道将于 11 月 1 日正式开启。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20an%20elegant%20award%20trophy%20on%20a%20light%20gray%20stage%20with%20warm%20amber%20spotlight%2C%20minimal%20ceremony%20aesthetic&width=1200&height=700&seq=news-award-2026&orientation=landscape',
    body: [
      '2026 年度观众选择奖提名名单今日公布。本次共设置最佳影片、最佳剧集、最佳综艺、最佳导演、最佳编剧、最佳表演、最佳纪录片与年度惊喜作品八个奖项。',
      '提名由平台内容团队与特邀评审共同提名，最终结果完全由观众投票决定。投票通道将于 11 月 1 日开启，持续两周。',
      '今年共有一百二十余部作品进入评选范围，其中包括多部口碑极高的独立作品与纪录片。观众可在详情页看到作品是否进入提名名单。',
      '投票期间，平台将陆续上线主创访谈与幕后花絮内容，敬请关注影视资讯频道的更新。',
      '完整提名名单可在本页下方相关文章中查看。',
    ],
    relatedIds: ['autumn-picks-2026', 'mountain-sings-doc', 'green-room-talk'],
  },
  {
    id: 'streaming-quality-guide',
    title: '实用指南：如何判断一部片子的清晰度是否值得下载',
    category: '影视资讯',
    date: '2026-08-30',
    author: '技术组 · 何斯',
    summary:
      '分辨率只是其中一项。码率、编码格式、音轨与调色版本，都会影响你最终看到的画面。这份小指南帮你少走弯路。',
    cover:
      'https://readdy.ai/api/search-image?query=Editorial%20photo%20of%20a%20modern%20home%20theater%20setup%20with%20large%20screen%20showing%20abstract%20color%20bars%2C%20dark%20navy%20room%2C%20warm%20accent%20lighting&width=1200&height=700&seq=news-quality-2026&orientation=landscape',
    body: [
      '很多人在选择资源时只看分辨率，但同样标注 1080p 的两份文件，画质可能相差很大。关键在于码率——每秒有多少数据被用来描述画面。',
      '一般来说，动作场面多、暗部细节丰富的影片需要更高的码率。一部两小时的动作片如果只有 2GB，那么它在夜景和快速移动镜头上几乎一定会出现压缩瑕疵。',
      '编码格式也很重要。在相同码率下，较新的编码往往能提供更好的画质，但对播放设备的要求也更高。',
      '音轨经常被忽略。有些资源视频很好，音轨却是低码率的立体声，这会让你在观看大场面时缺少很多信息。',
      '最后提醒：本平台的资源信息仅作介绍与参考，实际可观看的平台、清晰度与下载权限请以对应平台的说明为准。请支持正版内容。',
    ],
    relatedIds: ['steel-sky-visual', 'autumn-picks-2026', 'tv-production-trend'],
  },
];

export const getNewsById = (id: string): NewsItem | undefined => newsList.find((item) => item.id === id);

export const getRelatedNews = (item: NewsItem, limit = 3): NewsItem[] =>
  item.relatedIds
    .map((id) => newsList.find((n) => n.id === id))
    .filter((n): n is NewsItem => Boolean(n))
    .slice(0, limit);

export const latestNews = newsList.slice(0, 3);